import { render } from "./task.vue?vue&type=template&id=e8b91144&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"

import "./task.vue?vue&type=style&index=0&id=e8b91144&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b91144"]])

export default __exports__